module.exports = __webpack_public_path__ + "img/ttm-main-414.eae0353c.jpg";